import registerIbGroupedBarChartDirective from './groupedBarChart';
import registerIbPieChartsDirective from './pieChart';
import IbD3ScatterChart from './d3ScatterChart';

export default function registerCharts(angular) {
    const assessmentFrontendDirectives = angular.module('assessmentFrontendDirectives');
    registerIbPieChartsDirective(assessmentFrontendDirectives);
    registerIbGroupedBarChartDirective(assessmentFrontendDirectives);
    assessmentFrontendDirectives.directive('ibD3ScatterChart', ['$window', '$timeout', '$translate', (...deps) => new IbD3ScatterChart(...deps)]);
}